import ExploreContext from "./ExploreStore";
import PersonalContext from "./PersonalStore";
import LoginContext from "./LoginStore";
import MilestoreContext from "./MilestoneStore";
import MilestoneDetailContext from "./MilestoneDetailStore";
import TeamContext from "./TeamStore";
import TeamListContext from "./TeamListStore";
import IdealPoolStoreContext from "./IdealPoolStore";
import CompanyIntroStoreContext from "./CompanyIntroStore"
import React, { createContext } from "react";
export const RootStoreContext = createContext(null);
const RootStore = ({ children }) => {
  const ExploreStore = ExploreContext();
  const PersonalStore = PersonalContext();
  const LoginStore = LoginContext();
  const MilestoneStore = MilestoreContext();
  const MilestoneDetailStore = MilestoneDetailContext();
  const TeamStore = TeamContext();
  const TeamListStore = TeamListContext();
  const IdealPoolStore = IdealPoolStoreContext();
  const CompanyIntroStore = CompanyIntroStoreContext();

  return (
    <RootStoreContext.Provider
      value={{
        ExploreStore,
        PersonalStore,
        LoginStore,
        MilestoneStore,
        MilestoneDetailStore,
        TeamStore,
        TeamListStore,
        IdealPoolStore,
        CompanyIntroStore,
      }}
      // key={}
    >
      {children}
    </RootStoreContext.Provider>
  );
};
export default RootStore;
